<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-22 15:25:09
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <el-button style=" margin-right: 10px;" v-if="codeData.indexOf('17') != -1" @click="advancedSearch" type="primary"
          ></span>高级搜索</el-button
        >
        <div  class="batch-operation">
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item v-if="codeData.indexOf('280')" @click="caoSong" key="1"> 抄送栏目</a-menu-item>
              <a-menu-item v-if="codeData.indexOf('18') != -1" @click="handleMenuClick" key="2"> 删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /> </a-button>
          </a-dropdown>
        </div>
      </div>
      <div class="right">
        <el-select
          multiple
          clearable
          style="width: 400px"
          v-model="value"
          placeholder="按内容模型筛选"
        >
          <el-option
            :key="index"
            v-for="(item, index) in listPageData"
            :label="item.modelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          clearable
          multiple
          style="width: 400px; margin-left: 10px"
          v-model="states"
          placeholder="按稿件状态筛选"
        >
          <el-option label="已发布" value="4"> </el-option>
          <el-option label="已下线" value="5"> </el-option>
          <el-option label="审核通过" value="2"> </el-option>
        </el-select>
        <a-input-group compact>
          <a-select
            v-model:value="selectName"
            style="width: 140px; background: #ccc; margin-left: 12px"
          >
            <a-select-option
              @click="selectFn(item.value)"
              :key="index"
              v-for="(item, index) in selectArr"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-input
            v-model:value="valueName"
            placeholder="请输入搜索内容"
            style="width: 173px"
          />
        </a-input-group>
        <el-button type="primary"  @click="listSearch"
          ></span>查询</el-button
        >
      </div>
    </div>
    <coententTable
      :y="height"
      :x="1200"
      @handleTableChange="handleTableChange"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      :isSelectRow="isSelectRow"
      @selectedRowKeys="selectedRowKeys"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
      :rowKeys="rowKeys"
    >
     
      <template v-slot:state="scopeVal">
        {{
          scopeVal.scope.state == 0
            ? "草稿"
            : scopeVal.scope.state == 1
            ? "审核中"
            : scopeVal.scope.state == 2
            ? "审核通过"
            : scopeVal.scope.state == 3
            ? "审核失败"
            : scopeVal.scope.state == 4
            ? "已发布"
            : "下线"
        }}
      </template>
      <template v-slot:columnName="scopeVal">
        <div
          @click="openColumn(scopeVal.scope)"
          v-if="scopeVal.scope.number && codeData.indexOf('177') != -1"
          class="column-style"
        >
           <el-popover
            placement="left-start"
            title=""
            width="380"
            @show="showData(scopeVal.scope.id)"
            trigger="hover">
            <div>
                <div class="title-top">
                    <div class="title-top-left">预览关联栏目</div>
                    <div class="title-top-right">点击标签操作发布和下线</div>
                </div>
                <div class="item-one" v-for="(item,index) in showDataReq">{{index+1}}. {{item.parentsName.split(',').join('>')}}</div>
            </div>
            <el-button class="column-number" slot="reference">共{{ scopeVal.scope.number }}个</el-button>
          </el-popover>
         
        </div>
        <div  class="column-numberTwo" v-if="!scopeVal.scope.number">-</div>
      </template>
       <template v-slot:mediaData="scopeVal">
        <div
          @click="openNews(scopeVal.scope)"
          v-if="scopeVal.scope.mediaCount && codeData.indexOf('244') != -1"
          class="column-style"
        >
           <el-popover
            placement="left-start"
            title=""
            width="380"
            trigger="hover">
            <div>
                <div class="title-top">
                    <div class="title-top-left">预览关联新媒体</div>
                    <div class="title-top-right">点击标签操作发布和下线</div>
                </div>
                <div class="item-one" v-for="(item,index) in scopeVal.scope.mediaData.split(',')">{{index+1}}. {{item}}</div>
            </div>
            <el-button class="column-number" slot="reference">共{{ scopeVal.scope.mediaCount }}个</el-button>
          </el-popover>
        </div>
        <div class="column-numberTwo" v-if="!scopeVal.scope.mediaCount">-</div>
      </template>
      <template v-slot:stateRizhi="scopeVal">
        <a-popover trigger="click">
          <div class="content" slot="content">
            <div class="open-style" v-for="(item, index) in seeData">
              <div>操作人: {{ item.name || "--" }}</div>
              <div>操作时间: {{ item.time || "--" }}</div>
              <div>描述: {{ item.content || "--" }}</div>
            </div>
          </div>
          <a v-if="codeData.indexOf('19') != -1" @click="see(scopeVal.scope)">查看</a>
        </a-popover>
      </template>
      <template v-slot:operation="scopeVal">
          <div style="display: flex">
              <div  style="margin-right: 14px" v-if="codeData.indexOf('20') != -1" @click="editAdmin(scopeVal.scope)" class="btnTwo">编辑</div>
                <div
                  @click="open(scopeVal.scope)"
                  class="btnThree"
                  v-if="codeData.indexOf('21') != -1 && (scopeVal.scope.state != 1 && scopeVal.scope.state != 4)"
                  >删除</div
                >
                <el-popover
                  v-else
                  placement="left-start"
                  trigger="hover">
                  <div>
                      <div>需将稿件在所有栏目中下线后才可删除</div>
                  </div>
                  <el-button  class="btnFour" slot="reference">删除</el-button>
                </el-popover>
          </div>
      </template>
    </coententTable>
    <advancedSearch
      @close="close"
      v-if="visible"
      :visible="visible"
    ></advancedSearch>
    <el-dialog
      title="确认删除稿件?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="handleClose"
      top="17%"
    >
      <span>确认删除此条稿件吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button type="danger" @click="deleteOne()">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看关联栏目"
      :visible.sync="dialogVisibleColum"
      width="535px"
      class="column-box column-box-two"
      :before-close="handleCloseColum"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >若需彻底删除栏目关联，请到稿件编辑中进行设置
      </div>
      <coententTable
        :columns="columnsTwo"
        :dataSource="dataSourceColunm"
         :customSlot="customSlotTwo"
         :loading='isFabu'
         :y="300"
      >
      <template v-slot:state="scopeVal">
        {{
          scopeVal.scope.state == 0
            ? "草稿"
            : scopeVal.scope.state == 1
            ? "审核中"
            : scopeVal.scope.state == 2
            ? "审核通过"
            : scopeVal.scope.state == 3
            ? "审核失败"
            : scopeVal.scope.state == 4
            ? "已发布"
            : "下线"
        }}
      </template>
         <template v-slot:operation="scopeVal">
           <div style="display: flex;">
                <div
           v-if="scopeVal.scope.state == 2 || scopeVal.scope.state == 5"
            @click="release(scopeVal.scope)"
            class="btnTwo"
            >发布</div
          >
          <div  v-if="scopeVal.scope.state == 4" class="btnFour">发布</div>
          <div
           v-if="scopeVal.scope.state == 4"
            @click="Offline(scopeVal.scope)"
            style="margin-left: 20px"
            class="btnTwo"
            >下线</div
          >
           <div style="margin-left:24px"  v-if="scopeVal.scope.state == 2 || scopeVal.scope.state == 5" class="btnFour">下线</div>
           </div>
        </template>
      </coententTable>
      <div class="footer-style">
          <a-button @click="allXiaXian" size='large' type="primary">
            全部发布
          </a-button>
          <a-button @click="allFabu" style="margin-left:12px" size='large' >全部下线</a-button>
      </div>
    </el-dialog>


    <el-dialog
      title="查看关联新媒体"
      :visible.sync="dialogVisibleNews"
      width="700px"
      class="column-box"
      :before-close="handleCloseNews"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >若需彻底删除栏目关联，请到对应新媒体平台进行操作
      </div>
      <coententTable
        :columns="columnsThree"
        :dataSource="dataSourceNews"
         :customSlot="customSlotNews"
      >
      <template v-slot:type="scopeVal">
        {{
          scopeVal.scope.type == 1
            ? "公众号"
            : scopeVal.scope.type == 2
            ? "微博"
            : scopeVal.scope.type == 3
            ? "头条" : "抖音"
        }}
      </template>
      <!-- <template v-slot:state="scopeVal">
        {{
          scopeVal.scope.state == 0
            ? "已提交"
            : scopeVal.scope.state == 1
            ? "已存入草稿发布失败"
            : scopeVal.scope.state == 2
            ? "存入草稿失败"
            : scopeVal.scope.state == 3
            ? "发布中"
            : scopeVal.scope.state == 4
            ? "发布成功"
            : scopeVal.scope.state == 5
            ? "发布失败"
            : scopeVal.scope.state == 6
            ? "账户未授权"  : scopeVal.scope.state == 9?"审核通过"
            : "无封面图片"
        }}
      </template> -->
         <template v-slot:operation="scopeVal">
              <div style="display:flex">
                  <div
                    v-if="[1,2,5,7,9].indexOf(scopeVal.scope.state) != -1 && codeData.indexOf('245') != -1"
                      @click="releaseNews(scopeVal.scope)"
                      style="margin-right: 20px"
                      class="btnTwo"
                      >发布</div
                    >
                    <div class="btnFour"  v-if="[1,2,5,7,9].indexOf(scopeVal.scope.state) == -1 && scopeVal.scope.state != 6">发布</div>
                    <div
                      v-if="scopeVal.scope.state == 6 && codeData.indexOf('246') != -1"
                      @click="authorization(scopeVal.scope)"
                      class="btnTwo"
                      style="width:84px"
                      >重新授权</div
                    >
              </div>
         
        </template>
      </coententTable>
    </el-dialog>
    <choose-column
      :isColumn="isColumn"
      @colseChooseColumn="colseChooseColumn"
      @setColumnIds="setColumnIds"
      ref="chooseColumn"
      v-if="isColumn"
      :isCaoSong="true"
    ></choose-column>
  </div>
</template>

<script>
import {
  selectListPage,
  listPage,
  selectListById,
  deleteById,
  selectListPageKu,
  selectList,
  toColumnExamine,
  toColumnOffline,
  selectMediaConfig,
  getPreAuthCodet,
  getOauth,
  getDouyinCode,
  wxRelease,
  columnManuscriptBatchCopy,
} from "../all_manuscripts";
import coententTable from "@/components/coentent_table.vue";
import advancedSearch from "./advanced_search.vue";
import ChooseColumn from "../../Manuscripts/choose_column.vue";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      selectName: "标题",
      valueName: "",
      selectValue: 1,
      isColumn: false,
      dialogVisibleColum: false,
      height: 0,
      value: [],
      dataSourceNews: [],
      // selectDatas:[],
      isFabu: false,
      selectDatas:[],
      columnsThree: [
        {
          title: "关联新媒体",
          dataIndex: "mediaName",
          ellipsis: true,
          width: 120,
        },
        {
          title: "所属平台",
          dataIndex: "type",
          ellipsis: true,
          scopedSlots: { customRender: "type" },
          width: 120,
        },
        {
          title: "状态",
          dataIndex: "publishMsg",
          ellipsis: true,
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 194,
           // fixed: "right",
        },
      ],
      value2: "",
      visible: false,
      states: [],
      selectArr: [
        {
          label: "标题",
          value: "1",
        },
        {
          label: "创作人员",
          value: "0",
        },
      ],
      columnsTwo: [
        {
          title: "关联栏目",
          dataIndex: "columnName",
          ellipsis: true,
          width: 120,
        },
        {
          title: "状态",
          dataIndex: "state",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "state" },
        },
        {
          title: "操作",
          dataIndex: "title",
          scopedSlots: { customRender: "action" },
           fixed: "right",
        },
      ],
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          key: "title",
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        }
        },
        {
          title: "内容模型",
          dataIndex: "modelNames",
          key: "modelNames",
          width: 120,
          ellipsis: true,
        },
        {
          title: "稿件状态",
          dataIndex: "state",
          key: "state",
          scopedSlots: { customRender: "state" },
          width: 120,
        },
        {
          title: "关联栏目",
          dataIndex: "columnName",
          key: "columnName",
          scopedSlots: { customRender: "columnName" },
          width: 120,
        },
        {
          title: "关联新媒体",
          dataIndex: "mediaData",
          key: "mediaData",
          scopedSlots: { customRender: "mediaData" },
          width: 120,
        },
        {
          title: "创作人员",
          dataIndex: "manName",
          key: "manName",
          width: 120,
        },
        {
          title: "日志",
          dataIndex: "stateRizhi",
          key: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 174,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "state",
          customRender: "state",
        },
        {
          name: "columnName",
          customRender: "columnName",
        },
        {
          name: "mediaData",
          customRender: "mediaData",
        },
      ],
      customSlotTwo: [
        {
          name: "state",
          customRender: "state",
        },
      ],
      customSlotNews: [
        {
          name: "state",
          customRender: "state",
        },
        {
          name: "type",
          customRender: "type",
        },
      ],
      rowKeys: [],
      seeData: {},
      loading: false,
      isSelectRow: true,
      listPageData: [],
      loading: false,
      dialogVisibleTwo: false,
      dataSourceColunm: [],
      itemColumn: {},
      codeData: [],
      dialogVisibleNews: false,
      width: 0,
      selectChooseIds: [],
      showDataReq: [],
    };
  },
  props: ["type"],
  components: {
    coententTable,
    advancedSearch,
    ChooseColumn,
  },
  mounted() {
    let current = sessionStorage.getItem("draManuscriptsPage");
    if (current) {
      this.pagination.current = current;
    }
    this.getList();
    this.getListPage();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    showData(id) {
      this.showDataReq = [];
      selectList({ id: id }).then((res) => {
        if (res.code == 0) {
          this.showDataReq = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    caoSong() {
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      this.isColumn = true;
      this.$nextTick(() => {
        this.$refs.chooseColumn.getColumnTree();
      });
    },
    setColumnIds(data) {
      this.selectChooseIds = data.columnIds;
      if (this.selectChooseIds.length == 0) {
        message.error("请选择抄送的栏目");
        return false;
      }
      let manuscriptIds = [];
       let arrayDataTwo = [];
        for (let index = 0; index < this.selectDatas.length; index++) {
          const element = this.selectDatas[index];
          if(this.rowKeys.indexOf(element.id) != -1){
              arrayDataTwo.push(element)
          }
          
        }
      for (let index = 0; index < arrayDataTwo.length; index++) {
        const element = arrayDataTwo[index];
        manuscriptIds.push({
            manuscriptId: element.id,
            id:0,
            importState:0,
            state:element.state,
        });
      }
      columnManuscriptBatchCopy({
        manuscriptIds: manuscriptIds,
        columnId: this.selectChooseIds,
      }).then((res) => {
        if (res.code == 0) {
          this.isColumn = false;
          this.rowKeys = [];
          this.selectDatas = [];
          this.pagination.current = 1;
          this.getList();
        }
      });
    },
    colseChooseColumn() {
      this.isColumn = false;
    },
    authorization(item) {
      if (item.type == 1) {
        getPreAuthCodet({ id: sessionStorage.getItem("siteId") }).then(
          (res) => {
            if (res.code == 0) {
              window.open(`${res.data.oauthUrl}`);
            }
          }
        );
      }
      if (item.type == 2) {
        getOauth({ id: sessionStorage.getItem("siteId") }).then((res) => {
          if (res.code == 0) {
            window.open(`${res.data.oauthUrl}`);
          }
        });
      }
      if (item.type == 3) {
      }
      if (item.type == 4) {
        getDouyinCode({ id: sessionStorage.getItem("siteId") }).then((res) => {
          if (res.code == 0) {
            window.open(`${res.data.oauthUrl}`);
          }
        });
      }
    },
    handleCloseNews() {
      this.dialogVisibleNews = false;
      this.getList();
    },
    openNews(item) {
      this.getNewsList(item);
      this.dialogVisibleNews = true;
    },
    getNewsList(item) {
      selectMediaConfig({
        id: item.id || item.manuscriptId,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSourceNews = res.data;
        }
      });
    },
    release(item) {
      this.isFabu = true;
      toColumnExamine([
        {
          manuscriptId: this.itemColumn.id,
          id: item.id,
          columnId: item.columnId,
        },
      ]).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
        this.isFabu = false;
      });
    },
    allXiaXian() {
      this.isFabu = true;
      let array = [];
      this.dataSourceColunm.forEach((element) => {
        array.push({
          manuscriptId: this.itemColumn.id,
          id: element.id,
          columnId: element.columnId,
        });
      });
      toColumnExamine(array).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
        this.isFabu = false;
      });
    },
    Offline(item) {
      this.isFabu = true;
      toColumnOffline([
        {
          manuscriptId: this.itemColumn.id,
          id: item.id,
          columnId: item.columnId,
        },
      ]).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
        this.isFabu = false;
      });
    },
    allFabu() {
      this.isFabu = true;
      let array = [];
      this.dataSourceColunm.forEach((element) => {
        array.push({
          manuscriptId: this.itemColumn.id,
          id: element.id,
          columnId: element.columnId,
        });
      });
      toColumnOffline(array).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
        this.isFabu = false;
      });
    },
    openColumn(item) {
      this.dialogVisibleColum = true;
      this.dataSourceColunm = [];
      this.isFabu = true;
      this.itemColumn = item;
      selectList({ id: item.id }).then((res) => {
        if (res.code == 0) {
          this.dataSourceColunm = res.data;
          this.isFabu = false;
        }
      });
    },
    releaseNews(item) {
      wxRelease({
        manuscriptId: item.manuscriptId,
        releaseId: item.releaseId,
        mediaId: item.mediaId,
        configId: item.configId,
        mediaName: item.mediaName,
      }).then((res) => {
        if (res.code == 0) {
          this.getNewsList(item);
        }
      });
    },
    handleCloseColum() {
      this.dialogVisibleColum = false;
      //this.getList();
    },
    advancedSearch() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    getListPage() {
      listPage({
        siteId: sessionStorage.getItem("siteId"),
        current: 1,
        size: 100000000,
      }).then((res) => {
        if (res.code == 0) {
          this.listPageData = JSON.parse(JSON.stringify(res.data.records));
        }
      });
    },
    see(item) {
      selectListById({
        id: item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.seeData = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    handleMenuClick() {
      const _this = this;
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      this.$confirm({
        title: "操作提示",
        content: "确定批量删除吗?",
        centered: true,
        onOk() {
          return new Promise((resolve, reject) => {
            deleteById({
            idList: _this.rowKeys,
          }).then((res) => {
            if (res.code == 0) {
              _this.getList();
              _this.rowKeys = [];
              setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            }
          });
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
        class: "test",
      });
    },
    selectFn(value) {
      this.selectValue = value;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    editAdmin(item) {
      sessionStorage.setItem("manuscriptsType", this.type);
      sessionStorage.setItem("draManuscriptsPage", this.pagination.current);
      let routeData = this.$router.resolve({
        path: "/index/content/manuscripts_edit",
        query: {
          id: item.id,
          title: "编辑稿件",
          islast: true,
          type: this.type,
          isAllman: true,
        },
      });
       window.open(routeData.href, '_blank');
    },
    getList() {
      this.loading = true;
      selectListPageKu({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.valueName,
        siteId: sessionStorage.getItem("siteId"),
        type: this.selectValue,
        labelType: 0,
        states: this.states.join(","),
        modelId: this.value.join(","),
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if (this.pagination.total > 0) {
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 400;
            })();
          };
        }
        if (this.pagination.current != 1 && this.dataSource.length == 0) {
          this.pagination.current--;
          this.getList();
        }
        this.loading = false;
        sessionStorage.removeItem("draManuscriptsPage");
        sessionStorage.removeItem("manuscriptsType");
      });
    },
    onShowSizeChange(current) {
      console.log();
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys,selectedRows) {
      this.rowKeys = keys;
      this.selectDatas.push(...selectedRows)
    },
    handleTableChange() {},
    handleClose() {
      this.dialogVisibleTwo = false;
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.dialogVisibleTwo = true;
    },
    deleteOne() {
      deleteById({
        idList: [this.item.id],
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.getList();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    padding: 24px;
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
    }
    .icon-search-folder:before {
      color: #fff;
      margin-right: 5px;
    }
    .batch-operation {
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      width: 768px;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.column-style {
  display: flex;
  cursor: pointer;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.column-box {
  /deep/ .ant-table-body {
    max-height: 450px;
    overflow: auto;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 10px;
  }
}
.footer-style {
  text-align: right;
  margin-right: 23px;
  margin-bottom: 12px;
}
.column-box-two, .column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
/deep/ .ant-table {
  overflow-x: auto;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
.table-title {
  width: 660px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
</style>